import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

interface PropsType {
    height?: number;
    isTransparent?: boolean;
    width?: number;
}

type PopupOverlayContainerType = Pick<PropsType, 'isTransparent'>;

export const PopupOverlayContainer = styled('div', { label: 'PopupOverlayContainer' })<PopupOverlayContainerType>`
    ${({ isTransparent }): string => (isTransparent === true ? '' : 'background: rgba(255, 255, 255, 0.7)')};
    align-items: center;
    display: flex;
    inset: 0;
    justify-content: center;
    position: fixed;
    z-index: 5;
`;

type PopupWrapperType = Pick<PropsType, 'isTransparent' | 'width' | 'height'>;

export const PopupWrapper = styled('div', { label: 'PopupWrapper' })<PopupWrapperType>`
    ${({ isTransparent }): string => isTransparent === true ? '' : `background: ${mainColors.default.light}`};
    ${({ width }): string => (width === undefined ? '' : `max-width: ${width}px`)};
    border-radius: 12px;
    box-shadow: 0px 2px 24px 0px rgba(125, 125, 125, 0.16);
    display: flex;
    flex-flow: column nowrap;
    margin: auto;
    max-height: ${({ height }): string => height === undefined ? 'calc(100vh - 128px)' : `min(calc(100vh - 128px), ${height}px)`};
    overflow: hidden;
    position: fixed;
    width: calc(100% - 80px);
`;
